/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useLocation} from 'react-router-dom'
import {useMemo} from 'react'

export const usePDPSearchParams = (productId) => {
    const {search} = useLocation()

    // small optimization to avoid parsing the product search params in case they did not change, but something else in the search changed
    const [allParams, productSearch] = useMemo(() => {
        const allParams = new URLSearchParams(search)
        const productSearch = allParams.get(productId) || ''
        return [allParams, productSearch]
    }, [search, productId])

    const productParams = useMemo(() => new URLSearchParams(productSearch), [productSearch])

    return [allParams, productParams]
}
